import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import StakingEnabled from '../../../StakingEnabled/Preloader'
import Table from '../../../StakingTable/Preloader'
import commonStyles from '../../style.module.css'
import styles from './style.module.css'

function Preloader() {
    return (
        <div className={commonStyles.wrap}>
            <StakingEnabled />
            <div className={styles.title}>
                <Loader width={128} height={24} />
            </div>
            <Table />
            <div className={styles.title}>
                <Loader width={128} height={24} />
            </div>
            <Table />
        </div>
    )
}

export default Preloader
